import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { PhonePair } from "./PhoneMockups";
import { StoreButtons } from "./StoreButtons";

export const DownloadApp = ({ settings }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [70, -70]);
  return (
    <section ref={ref} id="download" data-testid="download-section" className="mx-auto max-w-[1400px] px-5 py-12 md:px-10">
      <div className="cut-corner-lg relative grid grid-cols-1 items-center gap-10 overflow-hidden bg-volt px-6 py-14 md:px-14 lg:grid-cols-2 lg:py-20">
        <div className="relative z-10">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-ink/70">05 — Aplikasi</p>
            <h2 className="mt-6 font-display text-4xl font-bold leading-[0.95] tracking-tight text-ink md:text-6xl">Download app BagiPulsa sekarang.</h2>
            <p className="mt-6 max-w-md text-base text-ink/80 md:text-lg">Convert pulsa, cek rate, dan pantau histori transaksi langsung dari HP kamu.</p>
            <div className="mt-10"><StoreButtons settings={settings} variant="volt" prefix="download" /></div>
          </Reveal>
        </div>
        <motion.div style={{ y }} className="relative">
          <div className="pointer-events-none absolute left-1/2 top-1/2 h-[110%] w-[110%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(255,255,255,0.6),transparent_62%)]" />
          <PhonePair className="relative mx-auto max-w-[480px]" />
        </motion.div>
      </div>
    </section>
  );
};
